import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { CanonicalService } from '../../shared/canonical.service';


@Component({
  selector: 'app-industry-news',
  templateUrl: './industry-news.component.html',
  styleUrls: ['./industry-news.component.css']
})
export class IndustryNewsComponent implements OnInit {

  heading = "Industry News";
  subheading = "Knowledge is the best way to be cyber secure";
  innerWidth:number = window.innerWidth;

  constructor(private titleService: Title, private metaTagService: Meta, private metaTagService1: Meta, private canonicalService: CanonicalService) {
    this.canonicalService.setCanonicalURL("https://www.protectt.ai/industry-news");
   }

  ngOnInit(): void {
    this.titleService.setTitle('Industry News | Cyber Security | Protectt.ai');
    this.metaTagService1.updateTag({ name: 'title', content: 'Mobile Security Software & App Industry News and Updates | Protectt.ai'});
    this.metaTagService.updateTag({ name: 'description', content: 'Get the Latest Industry News and key factors about cyber security which impact the global market. Know how Cyber security can have a huge impact on many sectors.'});
  }
  onResize(event:any){
    this.innerWidth = event.target.innerWidth;
  }

}
